<div class="container">
  <img class="image" [src]="url" alt="" />
</div>
